/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { AddressDto } from './AddressDto';
export type LocationDto = {
    address?: AddressDto;
    careOf?: string;
    cityStateZip?: string;
    latitude?: number;
    longName?: string;
    longitude?: number;
    name?: string;
    shortName?: string;
    status?: LocationDto.status;
    type?: LocationDto.type;
};
export namespace LocationDto {
    export enum status {
        PARTIAL = 'PARTIAL',
        FULL = 'FULL',
    }
    export enum type {
        TERMINAL = 'TERMINAL',
        WAREHOUSE_WITH_DOCK = 'WAREHOUSE_WITH_DOCK',
        WAREHOUSE_WITHOUT_DOCK = 'WAREHOUSE_WITHOUT_DOCK',
        STORE_FRONT = 'STORE_FRONT',
        RESIDENTIAL = 'RESIDENTIAL',
        CONTAINER_YARD = 'CONTAINER_YARD',
        DEPOT = 'DEPOT',
        OTHER = 'OTHER',
    }
}

